function debugLog(key: string = '', ...rest: unknown[]) {
    if (__DEV__) {
        let logKey = `[OneTV][${new Date().toLocaleTimeString()}]`;

        if (key) {
            logKey += `[${key}]`;
        }

        if (rest.length) {
            logKey += `:`;
        }

        const logParams = rest.reduce<
            (string | number | object | undefined | null)[]
        >((acc, param) => {
            if (typeof param === 'object') {
                return [...acc, param];
            }

            return [...acc, param];
        }, []);

        console.log(logKey, ...logParams);
    }
}

export default debugLog;
